import { ISelect } from '../types/shared';

export const formatParams = <T extends ISelect>(list: T[] = []): ISelect[] => {
    return list.map(({ id, name }) => ({ id, name }));
};
